import React from "react";

const GoogleSlidesIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_368_458)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask0_368_458",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 3,
  y: 1,
  width: 13,
  height: 18
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.4099 1.66667H5.05991C4.44359 1.66667 3.93933 2.17093 3.93933 2.78725V16.9813C3.93933 17.5976 4.44359 18.1019 5.05991 18.1019H14.7716C15.3879 18.1019 15.8922 17.5976 15.8922 16.9813V6.14899L11.4099 1.66667Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_368_458)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.4099 1.66667H5.05991C4.44359 1.66667 3.93933 2.17093 3.93933 2.78725V16.9813C3.93933 17.5976 4.44359 18.1019 5.05991 18.1019H14.7716C15.3879 18.1019 15.8922 17.5976 15.8922 16.9813V6.14899L13.2775 4.28135L11.4099 1.66667Z",
  fill: "#F4B400"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask1_368_458",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 3,
  y: 1,
  width: 13,
  height: 18
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.4099 1.66667H5.05991C4.44359 1.66667 3.93933 2.17093 3.93933 2.78725V16.9813C3.93933 17.5976 4.44359 18.1019 5.05991 18.1019H14.7716C15.3879 18.1019 15.8922 17.5976 15.8922 16.9813V6.14899L11.4099 1.66667Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1_368_458)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.3436 9.1372H7.48778C7.17962 9.1372 6.92749 9.38933 6.92749 9.69749V14.5533C6.92749 14.8615 7.17962 15.1136 7.48778 15.1136H12.3436C12.6518 15.1136 12.9039 14.8615 12.9039 14.5533V9.69749C12.9039 9.38933 12.6518 9.1372 12.3436 9.1372ZM12.1569 13.4328H7.67454V10.8181H12.1569V13.4328Z",
  fill: "#F1F1F1"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask2_368_458",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 3,
  y: 1,
  width: 13,
  height: 18
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.4099 1.66667H5.05991C4.44359 1.66667 3.93933 2.17093 3.93933 2.78725V16.9813C3.93933 17.5976 4.44359 18.1019 5.05991 18.1019H14.7716C15.3879 18.1019 15.8922 17.5976 15.8922 16.9813V6.14899L11.4099 1.66667Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask2_368_458)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.7377 5.82122L15.8922 9.97484V6.14899L11.7377 5.82122Z",
  fill: "url(#paint0_linear_368_458)"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask3_368_458",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 3,
  y: 1,
  width: 13,
  height: 18
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.4099 1.66667H5.05991C4.44359 1.66667 3.93933 2.17093 3.93933 2.78725V16.9813C3.93933 17.5976 4.44359 18.1019 5.05991 18.1019H14.7716C15.3879 18.1019 15.8922 17.5976 15.8922 16.9813V6.14899L11.4099 1.66667Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask3_368_458)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.4099 1.66667V5.02841C11.4099 5.64753 11.9114 6.14899 12.5305 6.14899H15.8922L11.4099 1.66667Z",
  fill: "#FADA80"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask4_368_458",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 3,
  y: 1,
  width: 13,
  height: 18
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.4099 1.66667H5.05991C4.44359 1.66667 3.93933 2.17093 3.93933 2.78725V16.9813C3.93933 17.5976 4.44359 18.1019 5.05991 18.1019H14.7716C15.3879 18.1019 15.8922 17.5976 15.8922 16.9813V6.14899L11.4099 1.66667Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask4_368_458)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.4099 1.66667V1.76005L15.7989 6.14899H15.8922L11.4099 1.66667Z",
  fill: "white",
  fillOpacity: 0.1
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask5_368_458",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 3,
  y: 1,
  width: 13,
  height: 18
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.4099 1.66667H5.05991C4.44359 1.66667 3.93933 2.17093 3.93933 2.78725V16.9813C3.93933 17.5976 4.44359 18.1019 5.05991 18.1019H14.7716C15.3879 18.1019 15.8922 17.5976 15.8922 16.9813V6.14899L11.4099 1.66667Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask5_368_458)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.05991 1.66667C4.44359 1.66667 3.93933 2.17093 3.93933 2.78725V2.88063C3.93933 2.26431 4.44359 1.76005 5.05991 1.76005H11.4099V1.66667H5.05991Z",
  fill: "white",
  fillOpacity: 0.2
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask6_368_458",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 3,
  y: 1,
  width: 13,
  height: 18
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.4099 1.66667H5.05991C4.44359 1.66667 3.93933 2.17093 3.93933 2.78725V16.9813C3.93933 17.5976 4.44359 18.1019 5.05991 18.1019H14.7716C15.3879 18.1019 15.8922 17.5976 15.8922 16.9813V6.14899L11.4099 1.66667Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask6_368_458)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.7716 18.0085H5.05991C4.44359 18.0085 3.93933 17.5042 3.93933 16.8879V16.9813C3.93933 17.5976 4.44359 18.1018 5.05991 18.1018H14.7716C15.3879 18.1018 15.8922 17.5976 15.8922 16.9813V16.8879C15.8922 17.5042 15.3879 18.0085 14.7716 18.0085Z",
  fill: "#BF360C",
  fillOpacity: 0.2
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask7_368_458",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 3,
  y: 1,
  width: 13,
  height: 18
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.4099 1.66667H5.05991C4.44359 1.66667 3.93933 2.17093 3.93933 2.78725V16.9813C3.93933 17.5976 4.44359 18.1019 5.05991 18.1019H14.7716C15.3879 18.1019 15.8922 17.5976 15.8922 16.9813V6.14899L11.4099 1.66667Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask7_368_458)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.5305 6.14899C11.9114 6.14899 11.4099 5.64753 11.4099 5.02841V5.12179C11.4099 5.74091 11.9114 6.24237 12.5305 6.24237H15.8922V6.14899H12.5305Z",
  fill: "#BF360C",
  fillOpacity: 0.1
})), /*#__PURE__*/React.createElement("path", {
  d: "M11.4099 1.66667H5.05991C4.44359 1.66667 3.93933 2.17093 3.93933 2.78725V16.9813C3.93933 17.5976 4.44359 18.1019 5.05991 18.1019H14.7716C15.3879 18.1019 15.8922 17.5976 15.8922 16.9813V6.14899L11.4099 1.66667Z",
  fill: "url(#paint1_radial_368_458)"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_368_458",
  x1: 13.8152,
  y1: 6.17785,
  x2: 13.8152,
  y2: 9.97542,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BF360C",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BF360C",
  stopOpacity: 0.02
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_368_458",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(4.318 1.99335) scale(19.2738)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_368_458"
}, /*#__PURE__*/React.createElement("rect", {
  width: 12.1212,
  height: 16.6667,
  fill: "white",
  transform: "translate(3.93933 1.66667)"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(GoogleSlidesIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;